export default "__VITE_ASSET__BTsZo5Pe__"